import { faFileArrowDown } from "@fortawesome/pro-solid-svg-icons"
import { translate } from "app/language/service"
import { IForm } from "form/model"
import {
  generateAndDownloadCoordinatesToCSVFile,
  generateAndDownloadGeoTargetToCSVFile,
  generateAndDownloadTerritoryToCSVFile
} from "form/tools/csv"
import { hasGeoTargets } from "form/tools/geo-targets"
import { hasCoordinates } from "form/tools/geo-targets-coordinates"
import { hasShapes } from "form/tools/geo-targets-shapes"
import React from "react"
import { SelectButton } from "ui/components/SelectButton"

interface IGeoTargetsExportButtonProps {
  form: IForm
}

const ID = "geo-target-export-button"

export const GeoTargetsExportButton = React.memo(({ form }: IGeoTargetsExportButtonProps) => (
  <SelectButton
    id={ID}
    icon={faFileArrowDown}
    title={translate("label.export")}
    items={[
      {
        id: `${ID}-select-field-option-0`,
        label: translate("label.export.coordinates.csv"),
        disabled: !hasCoordinates(form),
        onClick: () => generateAndDownloadCoordinatesToCSVFile(form.geoTargets.coordinates)
      },
      {
        id: `${ID}-select-field-option-1`,
        label: translate("label.export.territory.csv"),
        disabled: !hasShapes(form),
        onClick: () =>
          generateAndDownloadTerritoryToCSVFile(
            form.geoTargets.cities,
            form.geoTargets.postalCodes,
            form.geoTargets.states,
            form.geoTargets.countries,
            form.geoTargets.metropolitans
          )
      },
      {
        id: `${ID}-select-field-option-2`,
        label: translate("label.export.all.geo.data.csv"),
        disabled: !hasGeoTargets(form),
        onClick: () =>
          generateAndDownloadGeoTargetToCSVFile(
            form.geoTargets.coordinates,
            form.geoTargets.cities,
            form.geoTargets.postalCodes,
            form.geoTargets.states,
            form.geoTargets.countries,
            form.geoTargets.metropolitans
          )
      }
    ]}
  />
))
